import React from "react";
import EnhancedTable from "./DRLOrgTable";
import "../Assets/styles/newStyles/Payments.css";

export const DRLOrgs = () => {
  return (
    <div className="payments-main-container">
      <h1 className="admin-heading" style={{marginBottom: "10px" }}>
        DRL Orgs
      </h1>

      <EnhancedTable />
    </div>
  );
};
